import { useEffect } from 'react';
export function useOnEsc({ condition = true, action }) {
    useEffect(() => {
        if (!condition)
            return;
        // close when pressing ESC
        const listener = (e) => {
            if (condition && e.key === 'Escape')
                action();
        };
        document.addEventListener('keydown', listener);
        return () => {
            document.removeEventListener('keydown', listener);
        };
    }, [action, condition]);
}
//# sourceMappingURL=useOnEsc.js.map